import { render } from "./DetalheMedicamentoRevista.vue?vue&type=template&id=552ebf3c&ts=true"
import script from "./DetalheMedicamentoRevista.vue?vue&type=script&lang=ts"
export * from "./DetalheMedicamentoRevista.vue?vue&type=script&lang=ts"

import exportComponent from "/home/arthur/ProjetoVue/revista/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__